import {
	get,
	post,
	Post
} from "./http"
import {
	ADDRESS
} from './index'
export default {
	// 会员中心信息
	getVipMine(params) {
		let url = ADDRESS.address + '/vip-home/new-mine'
		return get(url, params)
	},
	// 会员支付页的会员信息
	getVipInfo(params) {
		let url = ADDRESS.address2 + '/vip/app-pay-new'
		return get(url, params)
	},
	// 会员视频列表
	getVipVideoList(params) {
		let url = ADDRESS.address + '/vip-home/user-home-video'
		return get(url, params)
	},
	// 会员福利社列表
	getBenefits(params) {
		let url = ADDRESS.address2 + '/app-vip/benefits-new'
		return get(url, params)
	},
	// 会员福利社详情
	getCounponDetail(params) {
		let url = ADDRESS.address2 + '/app-vip/coupon-detail-new'
		return get(url, params)
	},
	// 会员兑换码
	vipExchange(params) {
		let url = ADDRESS.address2 + '/vip-exchange/token-exchange'
		return get(url, params)
	},
	// 优惠券领取
	receiveCoupon(params) {
		let url = ADDRESS.address2 + '/app-vip/receive-coupon'
		return post(url, params)
	},
	// 查询续费状态
	checkAutoStatus(params) {
		let url = ADDRESS.address2 + '/vip/auto-pay-manage-new'
		return get(url, params)
	},
	// 苹果支付购买会员
	IOSPay(params) {
		let url = ADDRESS.address2 + '/vip-pay/itune-app-pay'
		return get(url, params)
	},
	// 判断IOS是否可购买
	IOSCanBuy(params) {
		let url = ADDRESS.address2 + '/vip-pay/ios-user-can-buy'
		return post(url, params)
	},
	// 安卓支付购买会员
	AndroidPay(params) {
		let url = ADDRESS.address2 + '/vip-pay/app-pay'
		return post(url, params)
	},
  // 20220317安卓连续包月优化
  openAndroidAutoNew(params){
    let url = ADDRESS.address4+'/vip-pay/wx-pay-and-contract'
    return post(url, params)
  },
	// 安卓在会员支付页开通自动续费
	openAndroidAuto(params) {
		let url = ADDRESS.address4 + '/vip-pay/check-auto-pay-and-pay'
		return post(url, params)
	},
	// 安卓在自动续费页开通自动续费
	openAndroiidAutoInAuto(params) {
		let url = ADDRESS.address4 + '/vip-pay/auto-pay'
		return post(url, params)
	},
	// 获取购买成功后赠送的优惠券列表
	getCounponList(params) {
		let url = ADDRESS.address + '/coupons/vip-gift'
		return get(url, params)
	},
	// 优惠券限制
	couponConfirm(params) {
		let url = ADDRESS.address + '/coupons/vip-coupon-show-confirm'
		return get(url, params)
	},
	// 关闭自动续费
	closeAutoStatus(params) {
		let url = ADDRESS.address2 + '/vip-pay/contract-terminate'
		return post(url, params)
	},
	// 会员记录
	getVipRecord(params) {
		let url = ADDRESS.address + '/vip-home/vip-buy-log'
		return get(url, params)
	},
	// 会员成长值
	getVipGrowth(params) {
		let url = ADDRESS.address + '/vip-home/user-growth'
		return get(url, params)
	},
	// 会员支付页分发
	getVipSend(params) {
		let url = ADDRESS.address2 + '/vip/get-vip-type'
		return get(url, params)
	},
	// 奥沙利文详情
	getFansDetail(params) {
		let url = ADDRESS.address2 + '/vip-star/f-display'
		return get(url, params)
	},
	// 二次分享
	getWXshare(params) {
		let url = ADDRESS.address + '/h5-common/f-wx-share-info'
		return get(url, params)
	},
	// 获取安卓连续包月支付状态
	getAutoStatus(params) {
		let url = ADDRESS.address2 + '/vip-pay/get-contract-and-pay-state'
		return get(url, params)
	},
	// 联合会员-兑换
	exchangeVip(params) {
		let url = ADDRESS.address2 + '/union-vip/exchange'
		return get(url, params)
	},
	// 检查支付状态
	getPayStatus(params) {
		let url = ADDRESS.address2 + '/vip-pay/check-pay-state'
		return Post(url, params)
	},
	// 支付控制接口
	getPayControl(params) {
		let url = ADDRESS.address2 + '/app-vip/pay-control'
		return get(url, params)
	},
	// 退款信息
	getRefundInfo(params) {
		let url = ADDRESS.address + '/vip-refund/vip-refund-info'
		return get(url, params)
	},
	// 退款提交
	submitRefund(params) {
		let url = ADDRESS.address + '/vip-refund/create-refund'
		return Post(url, params)
	},
	// 退款记录
	refundHistory(params) {
		let url = ADDRESS.address + '/vip-refund/get-refund-list'
		return get(url, params)
	},
	// 退款详情
	getRefundItemInfo(params) {
		let url = ADDRESS.address + '/vip-refund/get-refund-detail'
		return get(url, params)
	},
	// 不可售卖会员
	getNotSaleVip() {
		let url = ADDRESS.address2 + '/vip/get-not-sale-vip'
		return get(url)
	}
}
